import React, { useMemo } from "react";

import {
  createFormatterForProfileTypeWithItemsSuffix,
  FlamebearerMetrics,
  getProfileTypeTitle,
  ProfileType
} from "@platformsh/observability-graph/ContinuousProfiling";
import { PercentFormatter } from "@platformsh/observability-graph/Formatter";
import { useIntl } from "react-intl";

import ProfileTypeIcon from "../profileTypeIcon/ProfileTypeIcon";

import * as S from "./FlamebearerCallTooltip.styles";

type Props = {
  callMetrics: FlamebearerMetrics;
  profileType: ProfileType;
};

const percentFormater = new PercentFormatter();

const FlamebearerCallTooltip = ({ callMetrics, profileType }: Props) => {
  const intl = useIntl();
  const formatter = createFormatterForProfileTypeWithItemsSuffix(profileType);

  const components = useMemo(
    () => Object.entries(callMetrics.call.components),
    [callMetrics.call.components]
  );

  return (
    <S.Layout>
      <S.Label>{callMetrics.call.label}</S.Label>

      {components.length > 0 && (
        <div>
          {components.map(([key, value]) => (
            <S.Component key={key}>
              <S.ComponentKey>
                {key}
                {": "}
              </S.ComponentKey>
              <S.ComponentValue>{value}</S.ComponentValue>
            </S.Component>
          ))}
        </div>
      )}

      <S.ProfileType>
        <ProfileTypeIcon profileTypeName={profileType.name} />
        <S.ProfileTypeLabel>
          {getProfileTypeTitle(profileType.name)}
        </S.ProfileTypeLabel>
      </S.ProfileType>

      <S.CallStat>
        <S.CallStatType>
          {intl.formatMessage({ id: "conprof.flamebearer.tooltip.inclusive" })}
        </S.CallStatType>
        <S.CallStatValue>
          {formatter.toCondensedString(callMetrics.inclusive.rate)}
        </S.CallStatValue>
        <S.CallStatPercent>
          {percentFormater.toStandardString(callMetrics.inclusive.impact)}
        </S.CallStatPercent>
      </S.CallStat>
      <S.CallStat>
        <S.CallStatType>
          {intl.formatMessage({ id: "conprof.flamebearer.tooltip.exclusive" })}
        </S.CallStatType>
        <S.CallStatValue>
          {formatter.toCondensedString(callMetrics.exclusive.rate)}
        </S.CallStatValue>
        <S.CallStatPercent>
          {percentFormater.toStandardString(callMetrics.exclusive.impact)}
        </S.CallStatPercent>
      </S.CallStat>

      <S.Footer>
        {intl.formatMessage({ id: "conprof.flamebearer.tooltip.footer" })}.
      </S.Footer>
    </S.Layout>
  );
};

export default FlamebearerCallTooltip;
